import { useTranslation } from 'react-i18next';

import { X } from 'lucide-react';

import { useGoBack } from '@muzly/shared';

/**
 * 진단에서 나가는 문(덱 p5·p6의 X).
 *
 * **아무것도 지우지 않는다.** 중간 진행(diagnosisProgress)이 남아야 홈 카드가 "이어서
 * 진단하기"를 낼 수 있다 — 나가기를 포기로 해석해 진행을 버리면, 두 번째 진단 앞에서
 * 잠깐 나간 사용자가 첫 번째부터 다시 찍는다.
 */

export const CloseDiagnosisButton = () => {
  const { t } = useTranslation();
  const goBack = useGoBack();

  return (
    <button
      type="button"
      onClick={() => void goBack()}
      aria-label={t('web.diagnosis.close')}
      className="flex h-11 w-11 shrink-0 items-center justify-center -mr-3 text-foreground"
    >
      <X className="h-5 w-5" aria-hidden="true" />
    </button>
  );
};
